import { render, staticRenderFns } from "./codeTableSon.vue?vue&type=template&id=060a5548&scoped=true&"
import script from "./codeTableSon.vue?vue&type=script&lang=js&"
export * from "./codeTableSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a5548",
  null
  
)

export default component.exports